
export interface Metrics {
    space: {
        xxs: string,
        xs: string,
        s: string,
        m: string,
        l: string,
        xl: string, 
    }
}

export interface Theme {
    metrics: Metrics
}

const theme: Theme = {
    metrics: {
        space: {
            xxs: '0.2rem',
            xs: '0.4rem',
            s: '1rem',
            m: '2rem',
            l: '4rem',
            xl: '8rem',
        }
    }
}

declare module "styled-components" {
    export interface DefaultTheme extends Theme {
        
    }
}

export default theme;